export * from "-!../../node_modules/_vue-loader@15.9.1@vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../node_modules/_vue-loader@15.9.1@vue-loader/lib/index.js??vue-loader-options!./confirm-order-panel.vue?vue&type=template&id=8e7c0c9a&"


//////////////////
// WEBPACK FOOTER
// ./src/components/confirm-order-panel.vue?vue&type=template&id=8e7c0c9a&
// module id = 53
// module chunks = 0